var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-menu'),_vm._v(" "),(_vm.loadingScreen)?_c('loading-screen'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"container profile-container"},[_c('div',{staticClass:"profile"},[_c('h1',[_vm._v("Identidade de Saúde")]),_vm._v(" "),(!_vm.loadingScreen && _vm.values)?_c('card-health-id',{attrs:{"data":_vm.values}}):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-040ae6bc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HealthIdDigital/HealthIdDigital.vue
// module id = 856
// module chunks = 1